module.exports = __webpack_public_path__ + "3c5cae3a262c933983c987a21e75300e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-harry.png
// module id = 2334
// module chunks = 0